// Router-navigation indirection. The React router is not wired yet; App
// registers the real navigate function on mount via setNavigateFn(). Until
// then, navigate() is a no-op that warns. Ported Angular `router.navigate`
// call sites go through navigate().

export interface NavigateOptions {
  /** Query string (with or without a leading '?'). */
  search?: string;
  replace?: boolean;
}

export type NavigateFn = (path: string, opts?: NavigateOptions) => void;

export let navigateFn: NavigateFn = (path: string, opts?: NavigateOptions) => {
  console.warn('[navigation] navigate() called before the router was registered:', path, opts);
};

export function setNavigateFn(fn: NavigateFn): void {
  navigateFn = fn;
}

export function navigate(path: string, opts?: NavigateOptions): void {
  navigateFn(path, opts);
}
